<script>
export default {
  name: 'ReviewProductInfo',
  props: {
    product: {
      type: Object,
      required: false,
    },
  },
};
</script>

<template>
  <v-card-text>
    <v-layout>
      <v-flex class="mx-2">
        <b>{{ $t('review.reviewProductInfo.site') }}: </b>
          {{ product.siteName }} / {{ product.areaName }} / {{ product.countryName }}
      </v-flex>
      <v-flex class="mx-2 align-content-end text-xs-right">
        <b>{{ $t('review.reviewProductInfo.supplier') }}: </b>
        {{ product.supplierName }} / {{ product.accommodationName }}
      </v-flex>
    </v-layout>
  </v-card-text>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewProductInfo.vue